import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from "react-html-parser";
import { generate as generateReportLinks, czSk, redirectToRepi } from './reportLinks';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { entityIdentRowActions } from '../../store/entityIdentRowStore';
import { popupActions } from '../../store/popupStore';
import { bindActionCreators } from 'redux'
import { isObjectPathDefined } from '../../store/apiWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactResizeDetector from 'react-resize-detector';

import './reportSelectionMenu.scss';

class ReportSelectionMenu extends React.Component {
    state = { activeLinkChanged: true, moveButtonsActive: false, movePos: 0, isBeginPos: true, isEndPos: false, hasControls: false, dotOffsetLeft: -1 };
    repSelRef = undefined;

    componentDidMount() {
        this.props.ensureEntityInfo(this.props.entityId);
        window.addEventListener("resize", this.handleWindowResize);
    }

    componentDidUpdate(prevProps, _) {
        if (this.previousActiveLink !== this.activeLink) {
            this.previousActiveLink = this.activeLink;
            this.setState({ activeLinkChanged: true });
        } else if (this.state.activeLinkChanged) {
            this.setState({ activeLinkChanged: false });
        }
        if (prevProps.entityId !== this.props.entityId) {
            this.props.ensureEntityInfo(this.props.entityId);
            this.resolveDot();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.entityId !== this.props.entityId || this.state.activeLinkChanged !== nextState.activeLinkChanged ||
            ((!isObjectPathDefined(this.props.entityInfos[this.props.entityId], 'result')) && (isObjectPathDefined(nextProps.entityInfos[nextProps.entityId], 'result'))) ||
            nextProps.report.isLoading !== this.props.report.isLoading || nextProps.report.reportType !== this.props.report.reportType ||
            this.state.movePos !== nextState.movePos || this.state.hasControls !== nextState.hasControls ||
            this.state.dotOffsetLeft !== nextState.dotOffsetLeft ||
            (this.props.activeLanguage && this.props.activeLanguage.code !== nextProps.activeLanguage.code) ||
            ((((this.props.user || {}).authentication || {}).profile || {}).displaySettings !== (((nextProps.user || {}).authentication || {}).profile || {}).displaySettings);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowResize);
    }

    handleWindowResize = (e) => {
        this.solveControls();
        this.resolveDot();
    }

    render() {
        if (!(this.props.entityId &&
            this.props.entityInfos[this.props.entityId] &&
            !this.props.entityInfos[this.props.entityId].isLoading &&
            this.props.entityInfos[this.props.entityId].result))
            return null;

        return this.renderContent();
    }

    renderContent = () => {
        return (<>
            {!this.props.user.authentication.limitedUser &&
                <div className={classnames('tabs-subheader-wrapper shadowed', { 'tinted': this.isTinted() })}>
                    {this.state.hasControls && <span className={classnames({ 'active': !this.state.isBeginPos })} onClick={(e) => this.scroll(e, 'left')}>
                        <FontAwesomeIcon icon='angle-left' />
                    </span>}
                    <div>{this.renderDots()}</div>
                    {this.state.hasControls && <span className={classnames({ 'active': !this.state.isEndPos })} onClick={(e) => this.scroll(e, 'right')}>
                        <FontAwesomeIcon icon='angle-right' />
                    </span>}
                </div>
            }
        </>);
    }

    scroll = (event, dir) => {
        event.preventDefault();
        const min = 0;
        const max = this.repSelRef.scrollWidth - this.repSelRef.offsetWidth;
        const shift = this.repSelRef.offsetWidth / 2;
        const movePos = (dir === 'left') ? Math.max(min, this.state.movePos - shift) : Math.min(max, this.state.movePos + shift);

        if (this.repSelRef.scrollTo) {
            this.repSelRef.scrollTo({ left: movePos, behavior: 'smooth' });
        } else {
            this.repSelRef.scrollLeft = movePos;
        }
        this.setState({ movePos, isBeginPos: movePos === min, isEndPos: movePos === max });
    }

    renderDots = () => {
        const entityInfo = this.props.entityInfos[this.props.entityId].result || {};
        const entityType = entityInfo.type === 2 ? 2 : entityInfo.entrepreneur === true ? 3 : 1;

        return (
            <div ref={el => this.linkRef(el)} className='tabs tabs-subheader'>
                <div className='selection-menu-wrapper' style={this.state.hasControls ? {} : { width: '100%' }}>
                    <ReactResizeDetector handleWidth refreshMode='debounce' refreshRate={500} onResize={this.solveControls()} />
                    <div className={classnames('report-selection-menu', { "tinted": this.isTinted() })}>
                        {generateReportLinks(this.props.entityId, entityInfo.reports, true, false, entityType)
                            .filter(link => link.type === 'QR' || link.type === 'AR' || czSk(link.primaryAttr, "AccessCzechData", "AccessSlovakData") === true)
                            .sort((a, b) => a.tabOrder - b.tabOrder)
                            .map(link =>
                                <div key={link.translationKey} ref={el => {
                                    if (el && el.children[0].className.indexOf('active-link') !== -1) {
                                        this.activeLink = el;
                                    }
                                }}>
                                    {link.type == 'REPI' ? <NavLink
                                        className='report-selection-menu-link'
                                        to="#"
                                        onClick={(e) => {e.preventDefault(); e.stopPropagation(); redirectToRepi(link.url, e.button === 1, this.props); return false;}}
                                        onAuxClick={(e) => {e.stopPropagation(); e.preventDefault(); redirectToRepi(link.url, e.button === 1, this.props); return false; }} 
                                        activeClassName='active active-link bold-text'
                                    >
                                        <span className='link-long-name'>
                                            {ReactHtmlParser(this.props.translate(`${link.translationKey}.Description`))}
                                        </span>
                                        <span className='link-short-name' style={{ textTransform: 'capitalize' }}>
                                            {ReactHtmlParser(this.props.translate(`${link.translationKey}.Short`))}
                                        </span>
                                    </NavLink> : <NavLink
                                        className='report-selection-menu-link'
                                        to={link.url}
                                        activeClassName='active active-link bold-text'
                                    >
                                        <span className='link-long-name'>
                                            {ReactHtmlParser(this.props.translate(`${link.translationKey}.Description`))}
                                        </span>
                                        <span className='link-short-name' style={{ textTransform: 'capitalize' }}>
                                            {ReactHtmlParser(this.props.translate(`${link.translationKey}.Short`))}
                                        </span>
                                    </NavLink>}
                                </div>
                            )}
                    </div>
                    <div className={classnames('report-selection-menu-line-wrapper hide-on-mobile', { "tinted": this.isTinted() })} style={{ zIndex: 18 }}>
                        {!this.props.report.isLoading && <hr className='report-selection-menu-line gradient-2' ref={el => this.handleHrRef(el)} />}
                        {this.props.report.isLoading && <div className="search-report-progress-wrapper" style={{ margin: "0.4em 1em" }}>
                            <div className="search-progress searching" style={{ height: "0.1em" }}></div>
                        </div>}
                        <div
                            className='report-selection-menu-circle-wrapper'
                            style={{
                                left: (this.activeLink && this.repSelRef) ? `${this.activeLink.offsetLeft}px` : '',
                                width: (this.activeLink && this.repSelRef) ? `${this.activeLink.offsetWidth}px` : '',
                            }}
                        >
                            <div
                                className='report-selection-menu-circle gradient-2'
                                ref={el => this.handleCircleRef(el)}
                                style={{
                                    backgroundPosition: (this.activeLink && this.circleEl) ?
                                        `-${this.activeLink.offsetLeft + this.circleEl.offsetLeft}px` : '',
                                    backgroundSize: this.hrEl ? `${this.hrEl.offsetWidth}px` : ''
                                }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleHrRef = (el) => {
        if (el === null || el === undefined || this.hrEl === el) {
            return;
        }
        this.hrEl = el;
        this.resolveDot();
    }

    handleCircleRef = (el) => {
        if (el === null || el === undefined || this.circleEl === el) {
            return;
        }
        this.circleEl = el;
        this.resolveDot();
    }

    linkRef = (el) => {
        if (el === null || el === undefined || this.repSelRef === el) {
            return;
        }
        this.repSelRef = el;
        this.solveControls();
    }

    solveControls = () => {
        if (this.repSelRef === null || this.repSelRef === undefined) {
            return;
        }

        const hasControls = ((this.repSelRef.scrollWidth > this.repSelRef.offsetWidth) && (this.repSelRef.scrollWidth > this.repSelRef.offsetWidth + 2)); //this +2 is because of IE defect
        if (this.state.hasControls != hasControls) {
            this.setState({ hasControls })
        }
    }

    resolveDot = () => {
        const dotOffsetLeft = ((this.activeLink || {}).offsetLeft || 0) + ((this.circleEl || {}).offsetLeft || 0);
        if (dotOffsetLeft !== this.state.dotOffsetLeft) {
            this.setState({ dotOffsetLeft });
        }
    }

    isTinted = () => {
        try {
            return localStorage.locales_tint === 'header';
        } catch (error) {
            return false;
        }
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.entityIdentRow, report: state.report, user: state.userContext }),
    dispatch => bindActionCreators(({...entityIdentRowActions, ...popupActions }), dispatch)
)(ReportSelectionMenu)));
